import type { FunctionComponent } from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { buildProjectPath } from 'app/routes/paths/project';
import { useProposalContext } from 'features/project-versioning/hooks/useProposalContext';
import { ProjectHistoryPanel } from 'pages/projects/projectPage/selectedProject/projectHistory/ProjectHistoryPanel';
import { HISTORY_STORE } from 'state/history/historyStore';

interface OwnProps {}
type Props = OwnProps;

const ProjectHistoryPanelContainer: FunctionComponent<Props> = () => {
  const history = HISTORY_STORE((state) => state.history);
  const { projectId, isInProposal } = useProposalContext();
  const location = useLocation();

  const currentProjectHistory = projectId ? history[projectId] : undefined;

  const isOnProjectPath = Boolean(projectId && location.pathname.includes(buildProjectPath(projectId)));

  useEffect(() => {
    if (!projectId) return;
    if (!currentProjectHistory) return;

    const shouldClose = !isOnProjectPath || isInProposal;
    if (shouldClose && currentProjectHistory?.open) {
      HISTORY_STORE.getState().close(projectId);
    }
  }, [projectId, currentProjectHistory, isOnProjectPath, isInProposal]);

  if (!projectId) {
    return null;
  }
  return <ProjectHistoryPanel currentProjectHistoryState={currentProjectHistory} />;
};

export default ProjectHistoryPanelContainer;
